import { format, isToday, parseISO } from 'date-fns';

export function formatDate(utcDate: string): string {
  const date = parseISO(utcDate);

  if (isToday(date)) {
    return `Today, ${format(date, 'HH:mm')}`;
  } else {
    return format(date, 'd MMM, HH:mm');
  }
}
